import axios from 'axios';
import Cookies from 'js-cookie';

const deleteDataFromAPI = async (url, data = {}, headersObj = {}) => {
  url = `${process.env.REACT_APP_API_URL}${url}`;
  const tokenid = Cookies.get('authUser');
  const headers = { tokenid, ...headersObj };
  try {
    // Add data as query parameters if DELETE method does not support request body
    const queryString = new URLSearchParams(data).toString();
    const response = await axios.delete(`${url}?${queryString}`, {
      headers
    });
    return response.data;
  } catch (error) {
    return error.response
      ? error.response.data
      : { message: 'An error occurred' };
  }
};
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { deleteDataFromAPI };
